import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ConsultantChatGate from '../components/ConsultantChatGate';
import SEOHead from '../components/SEOHead';
import RequestCalculationForm from '../components/RequestCalculationForm';
import GenAiHero from '../components/gen-ai-creative/GenAiHero';
import GenAiPains from '../components/gen-ai-creative/GenAiPains';
import GenAiBenefits from '../components/gen-ai-creative/GenAiBenefits';
import GenAiTimeline from '../components/gen-ai-creative/GenAiTimeline';
import GenAiMetrics from '../components/gen-ai-creative/GenAiMetrics';
import GenAiCases from '../components/gen-ai-creative/GenAiCases';
import GenAiTrust from '../components/gen-ai-creative/GenAiTrust';
import GenAiContact from '../components/gen-ai-creative/GenAiContact';
import { reachMetrikaGoal } from '../lib/metrikaGoals';
import { PAGE_SEO } from '../data/pageSeo';
import {
  GEN_AI_CREATIVE_LANDING,
  buildGenAiCreativeLandingStructuredData,
} from '../data/genAiCreativeLanding';

const GenAiCreativePage = () => {
  const seo = PAGE_SEO['/gen-ai-creative'];
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => {
    reachMetrikaGoal('gen_ai_creative_cta_deck');
    setIsFormOpen(true);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonical={seo.canonical}
        image={seo.ogImage}
        url={seo.canonical}
        structuredData={buildGenAiCreativeLandingStructuredData()}
      />
      <Header />
      <main className="relative z-0 flex w-full flex-1 flex-col pt-16">
        <GenAiHero onOpenForm={openForm} />
        <GenAiPains />
        <GenAiBenefits />
        <GenAiTimeline />
        <GenAiMetrics />
        <GenAiCases />
        <GenAiTrust />
        <GenAiContact />
      </main>
      <Footer />
      <ConsultantChatGate />
      <RequestCalculationForm
        open={isFormOpen}
        onOpenChange={setIsFormOpen}
        title={GEN_AI_CREATIVE_LANDING.contact.formTitle}
        description={GEN_AI_CREATIVE_LANDING.contact.formDescription}
        submitLabel={GEN_AI_CREATIVE_LANDING.contact.submitLabel}
        calculatorData={{ requestType: 'gen_ai_creative' }}
      />
    </div>
  );
};

export default GenAiCreativePage;
